import {required,numeric} from "vuelidate/lib/validators";  
const sattalepmalzeme = {
    data() { 
      return {   
        sattalepmalzemeData: { 
              Aciklama: "",
              Talepid: "", 
              Malzemeid: null,
              Depokarsilananadet:0,
              Onaydurum:3,
              Sirano: 1,
              Adet: 1,
              Olcubirimi: null,
              Deleted: false,
          }, 
          FormDataType:{
              Aciklama:{FieldName:"Aciklama",Field:"textarea",FieldTitle:this.$t('sattalepmalzeme.AddEdit.Aciklama')},   
              Malzemeid:{FieldName:"Malzemeid",Field:"combobox",FieldTitle:this.$t('sattalepmalzeme.AddEdit.Malzemeid'),ComboDataArray:[]},
              Olcubirimi:{FieldName:"Olcubirimi",Field:"combobox",FieldTitle:this.$t('sattalepmalzeme.AddEdit.Olcubirimi'),ComboDataArray:[]},
              Sirano:{FieldName:"Sirano",Field:"input",FieldTitle:this.$t('sattalepmalzeme.AddEdit.Sirano'),FieldType:"number"},  
              Adet:{FieldName:"Adet",Field:"input",FieldTitle:this.$t('sattalepmalzeme.AddEdit.Miktar'),FieldType:"number"},  
          } 
      }
    }, 
    validations:{ 
      FormData: {  
        Aciklama:{},   
        Malzemeid:{required},
        Olcubirimi: {},
        Sirano:{required, numeric},  
        Adet:{required, numeric},  
      }
 
  },
  created(){
    this.ActionsSabitGet(201).then(res => {  
      for(var i=0; i<res.Data.length; i++)
        {
          this.FormDataType.Olcubirimi.ComboDataArray.push ({Id:res.Data[i].Id,Value:res.Data[i].Value})
        }    
    }); 


 

  }
}
export default sattalepmalzeme